const handleMegamenu = () => {
  /**
   * Open Megamenu on click nav with dropdown
   */
  $(".js-primary-megamenu > ul > .menu__item--has-dropdown").on(
    "mouseenter click",
    "> a",
    function () {
      const $this = $(this);
      const $parent = $this.closest("li");
      const index = $parent.index();
      const $megamenu = $(".nav--megamenu");

      $parent.addClass("is-active");

      $megamenu
        .find("> ul > li")
        .eq(index)
        .find(".megamenu")
        .addClass("is-open");

      if ($(window).innerWidth() <= 1020) {
        event.preventDefault();
      }
    }
  );

  /**
   * Close megamenu on mouseleave event if related target different megamenu object
   * @param  {[type]} event) {		const     $this [description]
   * @return {[type]}        [description]
   */
  $(".js-primary-megamenu > ul > .menu__item--has-dropdown").on(
    "mouseleave",
    "> a",
    function (event) {
      const $this = $(this);
      const $parent = $this.closest("li");
      const index = $parent.index();
      const $megamenu = $(".nav--megamenu");
      const $currentMegamenu = $megamenu
        .find("> ul > li")
        .eq(index)
        .find(".megamenu");

      if (
        $currentMegamenu !== event.relatedTarget &&
        !$currentMegamenu.has(event.relatedTarget).length
      ) {
        $currentMegamenu.removeClass("is-open");

        $parent.removeClass("is-active");
      }
    }
  );

  /**
   * Close megamenu on mouseleave
   */
  $(".megamenu").on("mouseleave", function (event) {
    const $this = $(this);
    const index = $this.closest("li").index();

    $(".nav--primary").find("> ul > li").eq(index).removeClass("is-active");

    $this.removeClass("is-open");
  });
};

handleMegamenu();
